import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(0);

  const faqs = [
    {
      id: 1,
      category: 'Všeobecné',
      question: 'Potrebujem stavebné povolenie na zasklenie balkóna?',
      answer: `Vo väčšine prípadov nie je potrebné stavebné povolenie, ale závisí to od typu nehnuteľnosti a miestnych predpisov.\n\nPre bytové domy je zvyčajne potrebný súhlas spoločenstva vlastníkov. Pre rodinné domy je zasklenie balkóna považované za údržbu, nie za stavbu.\n\nNaši technici vám poskytnú presné informácie na základe vašej konkrétnej situácie a pomôžeme s vybavením potrebných súhlasov.`,
      videoUrl: null
    },
    {
      id: 2,
      category: 'Inštalácia',
      question: 'Ako dlho trvá inštalácia zasklenia?',
      answer: `Doba inštalácie závisí od veľkosti a zložitosti projektu:\n\n• Malé balkóny (do 10m²): 1 deň\n• Stredné balkóny (10-20m²): 2-3 dni\n• Veľké terasy (nad 20m²): 3-5 dní\n\nInštalácia prebieha v pracovných dňoch od 8:00 do 17:00. Počas práce je balkón čiastočne neprístupný, ale zvyšok bytu nie je ovplyvnený.`,
      videoUrl: null
    },
    {
      id: 3,
      category: 'Materiály',
      question: 'Aký je rozdiel medzi jednoduchým, dvojitým a trojitým sklom?',
      answer: `Každý typ skla má svoje výhody:\n\n**Jednoduché sklo (45€/m²):**\n• Základná ochrana pred počasím\n• Vhodné pre letné využitie\n• Minimálna tepelná izolácia\n\n**Dvojsklo (65€/m²):**\n• Výrazne lepšia tepelná izolácia\n• Zníženie hluku o 60-70%\n• Celoročné využitie\n• Najobľúbenejšia voľba\n\n**Trojsklo (85€/m²):**\n• Maximálna tepelná izolácia\n• Zníženie hluku o 80%+\n• Najvyššia energetická účinnosť\n• Ideálne pre severné strany`,
      videoUrl: null
    },
    {
      id: 4,
      category: 'Údržba',
      question: 'Aká je údržba zasklených balkónov?',
      answer: `Zasklené balkóny sú veľmi jednoduché na údržbu:\n\n**Pravidelná údržba:**\n• Čistenie skla 2-3x ročne\n• Kontrola tesnení 1x ročne\n• Premazanie posuvných mechanizmov 1x ročne\n\n**Hliníkové profily:**\n• Bezúdržbové, nekorodujú\n• Občasné umytie mydlovou vodou\n• Žiadne natieranie ani ošetrovanie\n\n**Záruka:**\n• 5-10 rokov podľa typu\n• Bezplatný servis počas záruky\n• Náhradné diely dostupné 15+ rokov`,
      videoUrl: null
    },
    {
      id: 5,
      category: 'Ceny',
      question: 'Čo všetko je zahrnuté v cene zasklenia?',
      answer: `Naše ceny sú komplexné a zahŕňajú:\n\n**Materiál:**\n• Hliníkové profily\n• Bezpečnostné sklo\n• Tesnenia a príslušenstvo\n• Kotvenie a montážny materiál\n\n**Služby:**\n• Bezplatné zameranie\n• Profesionálna inštalácia\n• Odvoz odpadu\n• Záruka 5-10 rokov\n\n**Bez skrytých poplatkov:**\n• Doprava zadarmo\n• Žiadne príplatky za víkendy\n• Konečná cena bez DPH`,
      videoUrl: null
    },
    {
      id: 6,
      category: 'Technické',
      question: 'Môžem zasklenie otvárať a zatvárať?',
      answer: `Áno, naše systémy sú navrhnuté pre pohodlné používanie:\n\n**Posuvné panely:**\n• Ľahké posúvanie jednou rukou\n• Možnosť čiastočného otvorenia\n• Bezpečnostné zámky\n\n**Skladacie systémy:**\n• Kompletné otvorenie celej plochy\n• Panely sa skladajú k strane\n• Ideálne pre veľké terasy\n\n**Bezrámové systémy:**\n• Minimalistický dizajn\n• Plynulé posúvanie\n• Maximálny výhľad\n\nVšetky systémy majú kvalitné ložiská a sú testované na 10 000+ cyklov otvárania.`,
      videoUrl: null
    },
    {
      id: 7,
      category: 'Záruka',
      question: 'Aká je záruka a čo pokrýva?',
      answer: `Poskytujeme komplexnú záruku na všetky naše práce:\n\n**Základná záruka:**\n• 5 rokov - štandardné balíčky\n• 8 rokov - štandardný balíček\n• 10 rokov - prémiový balíček\n\n**Záruka pokrýva:**\n• Materiálové chyby\n• Chyby v montáži\n• Funkčnosť posuvných mechanizmov\n• Tesnosť proti vode a vetru\n\n**Servis:**\n• Bezplatný servis počas záruky\n• Reakcia do 48 hodín\n• Náhradné diely na sklade\n• Možnosť rozšírenej záruky na 15 rokov`,
      videoUrl: null
    },
    {
      id: 8,
      category: 'Platba',
      question: 'Aké sú možnosti platby a kedy sa platí?',
      answer: `Ponúkame flexibilné platobné podmienky:\n\n**Spôsoby platby:**\n• Hotovosť pri prevzatí\n• Bankový prevod\n• Platobná karta\n• Splátkový predaj (0% úrok)\n\n**Harmonogram platieb:**\n• 30% záloha pri objednávke\n• 70% pri dokončení a prevzatí\n• Možnosť rozloženia na 6-24 mesiacov\n\n**Bez skrytých poplatkov:**\n• Žiadne manipulačné poplatky\n• Doprava zadarmo\n• Zameranie zadarmo`,
      videoUrl: null
    }
  ];

  const categories = ['Všetky', ...Array.from(new Set(faqs.map(faq => faq.category)))];
  const [selectedCategory, setSelectedCategory] = useState('Všetky');

  const filteredFAQs = selectedCategory === 'Všetky' 
    ? faqs 
    : faqs?.filter(faq => faq?.category === selectedCategory);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? -1 : index);
  };

  const formatAnswer = (answer) => {
    return answer?.split('\n')?.map((line, index) => {
      if (line?.startsWith('**') && line?.endsWith('**')) {
        return (
          <strong key={index} className="text-primary font-semibold block mt-3 mb-1">
            {line?.replace(/\*\*/g, '')}
          </strong>
        );
      }
      if (line?.startsWith('•')) {
        return (
          <li key={index} className="ml-4 text-text-secondary">
            {line?.substring(1)?.trim()}
          </li>
        );
      }
      if (line?.trim() === '') {
        return <br key={index} />;
      }
      return (
        <p key={index} className="text-text-secondary leading-relaxed">
          {line}
        </p>
      );
    });
  };

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-accent/10 text-accent px-4 py-2 rounded-full mb-6">
            <Icon name="HelpCircle" size={20} />
            <span className="font-semibold">Často kladené otázky</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-6">
            Máte otázky? Máme odpovede
          </h2>
          <p className="text-xl text-text-secondary font-body max-w-3xl mx-auto leading-relaxed">
            Nájdite odpovede na najčastejšie otázky o zasklievaní balkónov. 
            Ak nenájdete odpoveď, kontaktujte nás.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories?.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-3 rounded-full font-semibold transition-smooth ${
                selectedCategory === category
                  ? 'bg-accent text-white shadow-cta'
                  : 'bg-white text-text-secondary hover:bg-accent/10 hover:text-accent border border-border'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {filteredFAQs?.map((faq, index) => (
              <div
                key={faq?.id}
                className="bg-white rounded-2xl shadow-lg border border-border overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full p-6 text-left flex items-center justify-between hover:bg-muted/50 transition-smooth"
                >
                  <div className="flex-1">
                    <div className="flex items-center space-x-3 mb-2">
                      <span className="bg-accent/10 text-accent px-3 py-1 rounded-full text-sm font-medium">
                        {faq?.category}
                      </span>
                    </div>
                    <h3 className="text-lg font-heading font-semibold text-primary pr-4">
                      {faq?.question}
                    </h3>
                  </div>
                  <div className={`transform transition-transform duration-300 ${
                    openFAQ === index ? 'rotate-180' : ''
                  }`}>
                    <Icon name="ChevronDown" size={24} color="var(--color-accent)" />
                  </div>
                </button>

                <div className={`overflow-hidden transition-all duration-300 ${
                  openFAQ === index ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                }`}>
                  <div className="p-6 pt-0 border-t border-border">
                    <div className="prose prose-sm max-w-none">
                      {formatAnswer(faq?.answer)}
                    </div>

                    {faq?.videoUrl && (
                      <div className="mt-6">
                        <div className="bg-muted rounded-lg p-4 flex items-center space-x-3">
                          <Icon name="Play" size={20} color="var(--color-accent)" />
                          <div>
                            <div className="font-semibold text-primary">Video vysvetlenie</div>
                            <div className="text-sm text-text-secondary">
                              Pozrite si detailné video k tejto téme
                            </div>
                          </div>
                          <button className="bg-accent text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-accent/90 transition-smooth">
                            Prehrať
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary to-accent rounded-2xl p-8 text-white max-w-2xl mx-auto">
            <Icon name="MessageCircle" size={48} color="white" className="mx-auto mb-4" />
            <h3 className="text-2xl font-heading font-bold mb-4 text-white">
              Nenašli ste odpoveď na vašu otázku?
            </h3>
            <p className="text-white/90 font-body mb-6">
              Naši odborníci sú tu pre vás. Kontaktujte nás a získajte odpovede na všetky vaše otázky.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => window.location.href = 'tel:+421905123456'}
                className="bg-white text-primary px-6 py-3 rounded-lg font-semibold hover:bg-white/90 transition-smooth inline-flex items-center justify-center space-x-2"
              >
                <Icon name="Phone" size={20} />
                <span>+421 905 123 456</span>
              </button>
              <button
                onClick={() => window.open('https://wa.me/+421905123456?text=Dobrý deň, mám otázku o zasklievaní balkóna.', '_blank')}
                className="bg-white/20 text-white border border-white/30 px-6 py-3 rounded-lg font-semibold hover:bg-white/30 transition-smooth inline-flex items-center justify-center space-x-2"
              >
                <Icon name="MessageCircle" size={20} />
                <span className="text-white">WhatsApp</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;